import { render, staticRenderFns } from "./Encargos.vue?vue&type=template&id=014989b2&"
import script from "./Encargos.vue?vue&type=script&lang=js&"
export * from "./Encargos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports